const initialState = {
  helpAdding: false,
  helpLoading: true,
  pageHelpLoading: false,
  contentDeleting: false,
  helpUpdating: false,
  helpContents: [],
  helpContent: null,
  helpContentsForExportLoading: false,
  helpContentsForExport: [],
  sendingContentsForImport: false,
};

export default initialState;
